// extracted by mini-css-extract-plugin
export default {"btn":"btnschedule_btn__DnPNd"};